export default __webpack_public_path__ + "static/media/placeholder-image.71ec2e68.svg";